import { Field } from '@kanda-libs/ks-component-ts';

import useAddressManual from './useAddressManual';

const AddressManual: React.FunctionComponent = function () {
  const {
    show,
    widgets: Widgets,
    buildingValidation,
    postcodeValidation,
    postcodeName,
    onPostcodeBlur,
  } = useAddressManual();
  if (!show) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-4">
      <Widgets.BuildingNumber
        validation={buildingValidation}
        placeholder="Building number"
      />
      <Widgets.BuildingName
        validation={buildingValidation}
        placeholder="Building name"
      />
      <Widgets.Line1 className="md:col-span-2" placeholder="Line 1" />
      <Widgets.Line2
        label="Line 2 (optional)"
        className="md:col-span-2"
        placeholder="Building number"
      />
      <Widgets.City label="City or Town" placeholder="City" />
      <Field.Validator validation={postcodeValidation}>
        <Field.Input
          name={postcodeName}
          label="Postcode"
          placeholder="Postcode"
          onBlur={onPostcodeBlur}
        />
      </Field.Validator>
      <Widgets.County label="County (optional)" placeholder="County" />
      <Widgets.Country placeholder="Country" />
    </div>
  );
};

export default AddressManual;
